import {get, post} from '../index'
export default {
  // 获取可用菜单列表
  getMenuList (querys) {
    return get('/diy/admin/menu/list', querys)
  },
  // 获取可用组件列表
  getComponentsList (querys) {
    return get('/diy/admin/components/list', querys)
  },
  // 获取列表
  getDiyList (querys) {
    return get('/diy/admin/DIY/list', querys)
  },
  // 新增
  addDiy (querys) {
    return post('/diy/admin/DIY/initOne', querys)
  },
  // 删除
  delDiy (querys) {
    return post('/diy/admin/DIY/delDiy', querys)
  },
  // 获取一个diy的所有菜单页面的数据
  getDiyData (querys) {
    return get('/diy/admin/DIY/getDiyData', querys)
  },
  // 保存一个diy的所有菜单页面的数据
  setDiyData (querys) {
    return post('/diy/admin/DIY/setDiyData', querys)
  },
  // 开启一个
  openADiy (querys) {
    return post('/diy/admin/DIY/openADiy', querys)
  },
  // 根据菜单key获取模块列表
  getMoudelByKey (querys) {
    return get('/diy/admin/Module/getMoudelByKey', querys)
  },
  // 获取默认diy配置
  getSystemDefaulDiy (querys) {
    return get('/diy/admin/DIY/getSystemDefaulDiy', querys)
  },
  // DIY组件列表及详情
  getlist (querys) {
    return post('/diy_shop/admin/components/list', querys)
  },
  // 保存diy
  saveDiy (querys) {
    return post('/diy_shop/admin/diy/rotationEditing',querys)
  },
  // 发布DIY商城页面
  releaseDiy (querys) {
    return post('/diy_shop/admin/DIY/rotationEditing_release',querys)
  }

}



// WEBPACK FOOTER //
// ./src/api/modules/diy.js